export class NumberUtils {
  static formatMoney(value?: string | number | null, fractionDigits: number = 2): string {
    return `$${Number(value ?? 0).toFixed(fractionDigits)}`;
  }

  static formatRate(value?: string | number | null, fractionDigits: number = 2): string {
    return Number(value ?? 0).toFixed(fractionDigits);
  }

  static toFixedDecimalString(value?: string | number | null, fractionDigits: number = 4): string {
    if (value === null || value === undefined || value === '') {
      return (0).toFixed(fractionDigits);
    }

    const numericValue = Number(value);
    if (Number.isNaN(numericValue)) {
      return String(value);
    }

    return numericValue.toFixed(fractionDigits);
  }

  // Same as toFixedDecimalString but keeps null distinct from 0 — used wherever an
  // empty rate must not be persisted/displayed as if it were USD 0.
  static toFixedDecimalStringOrNull(value?: string | number | null, fractionDigits: number = 4): string | null {
    if (value === null || value === undefined || value === '') {
      return null;
    }

    const numericValue = Number(value);
    if (Number.isNaN(numericValue)) {
      return String(value);
    }

    return numericValue.toFixed(fractionDigits);
  }
}
